module.exports = __webpack_public_path__ + "img/thirdPartyNodata.4aa9c174.svg";